import React, { memo } from 'react';
import PropTypes from 'prop-types';

import style from '../../style/components/signin/TwoFArow.module.scss';
import InputWithError from '../InputWithError';

const TwoFAEditRow = ({
  handleChange,
  handleCancel,
  handleConfirm,
  newName,
}) => (
  <div className={style.rowEdit}>
    <div className={style.left}>
      <InputWithError
        data-testid="mfa-row-update-name"
        label="Name"
        value={newName}
        onChange={handleChange}
        noMargin
        required
      />
    </div>
    <div className={style.right}>
      <idme-button
        data-testid="mfa-row-cancel-change"
        variant="secondary"
        text="Cancel"
        layout="content"
        type="button"
        size="small"
        onClick={handleCancel}
      />
      <idme-button
        data-testid="mfa-row-apply-change"
        variant="primary"
        text="Apply Change"
        layout="content"
        type="button"
        size="small"
        onClick={handleConfirm}
      />
    </div>
  </div>
);

TwoFAEditRow.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  newName: PropTypes.string,
};

export default memo(TwoFAEditRow);
